import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Select, Typography } from "antd";
import { SingleSelect } from "../customComponent/CustomSelect";

const { Option } = Select;

const { Text } = Typography;

const CarrierFormItemComponent = ({
  t,
  style,
  label,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  dataTMId
}) => {
  return (
    <Form.Item
      name="carrier"
      required={false}
      label={showLabel ? <Text strong={strong}>{label ? label : t("form.carrier.label")}</Text> : null}
      colon={false}
      rules={[{ required: required, message: t("form.carrier.error_required") }]}
      style={style}
    >
      <SingleSelect dataTMId={dataTMId} disabled={!editable} placeholder={t("form.carrier.placeholder")} allowClear>
        <Option value="fedex">{t("form.carrier.fedex")}</Option>
        <Option value="ups">{t("form.carrier.ups")}</Option>
        <Option value="us-post">{t("form.carrier.usps")}</Option>
        <Option value="dhl">{t("form.carrier.dhl")}</Option>
      </SingleSelect>
    </Form.Item>
  );
};

const CarrierFormItem = withTranslation()(CarrierFormItemComponent);

export { CarrierFormItem };
